import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import { API_BASE } from '../../config';
import './Registrations.css';

function Registrations() {
  const normalizeNicknameBody = (value) => {
    return value.replace(/[^a-zA-Z0-9_.-]/g, '');
  };

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    nickname: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'nickname') {
      setFormData((prev) => ({
        ...prev,
        [name]: normalizeNicknameBody(value)
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Пароли не совпадают');
      return;
    }

    try {
      const nicknameBody = normalizeNicknameBody(formData.nickname);
      if (!nicknameBody) {
        setError('Никнейм обязателен');
        return;
      }

      const nickname = `@${nicknameBody}`;
      setIsRegistering(true);

      const response = await fetch(`${API_BASE}/api/Account/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password,
          confirmPassword: formData.confirmPassword,
          firstName: formData.firstName,
          lastName: formData.lastName,
          nickname
        })
      });

      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(errorData || 'Ошибка регистрации');
      }

      setShowSuccessModal(true);
    } catch (err) {
      console.error('Registration error:', err);
      if (err.message === 'Failed to fetch') {
        setError('Ошибка соединения с сервером. Убедитесь, что API запущен.');
      } else {
        setError(err.message);
      }
    } finally {
      setIsRegistering(false);
    }
  };

  return (
    <div className="registration-page">

      <main className="registration-main">
        <h1 className="registration-title">Регистрация</h1>

        <div className="registration-form-wrap">
          <form onSubmit={handleSubmit} className="registration-form" noValidate>
            <div className="registration-row">
              <div className="registration-field-block">
                <label htmlFor="firstName" className="registration-label">Имя</label>
                <input
                  id="firstName"
                  name="firstName"
                  type="text"
                  required
                  autoComplete="given-name"
                  placeholder="введите имя"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="registration-input"
                />
              </div>

              <div className="registration-field-block">
                <label htmlFor="lastName" className="registration-label">Фамилия</label>
                <input
                  id="lastName"
                  name="lastName"
                  type="text"
                  required
                  autoComplete="family-name"
                  placeholder="введите фамилию"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="registration-input"
                />
              </div>
            </div>

            <div className="registration-row">
              <div className="registration-field-block">
                <label htmlFor="nickname" className="registration-label">Никнейм</label>
                <input
                  id="nickname"
                  name="nickname"
                  type="text"
                  required
                  autoComplete="username"
                  placeholder="nickname"
                  value={formData.nickname}
                  onChange={handleChange}
                  className="registration-input"
                />
              </div>

              <div className="registration-field-block">
                <label htmlFor="email" className="registration-label">Email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  autoComplete="email"
                  placeholder="admin@gmail.com"
                  value={formData.email}
                  onChange={handleChange}
                  className="registration-input"
                />
              </div>
            </div>

            <div className="registration-field-block">
              <div className="registration-pass-head">
                <label htmlFor="password" className="registration-label">Пароль</label>
                <span className="registration-pass-note">Минимальная длина 8 символов</span>
              </div>

              <div className="registration-input-wrap">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  required
                  autoComplete="new-password"
                  placeholder="введите свой пароль"
                  value={formData.password}
                  onChange={handleChange}
                  className="registration-input registration-input--pass"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="registration-pass-toggle"
                  aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                >
                  {showPassword ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  ) : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1 1l22 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <div className="registration-field-block">
              <label htmlFor="confirmPassword" className="registration-label">Повторите пароль</label>
              <div className="registration-input-wrap">
                <input
                  id="confirmPassword"
                  name="confirmPassword"
                  type={showConfirmPassword ? 'text' : 'password'}
                  required
                  autoComplete="new-password"
                  placeholder="введите придуманный пароль"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className="registration-input registration-input--pass"
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="registration-pass-toggle"
                  aria-label={showConfirmPassword ? 'Скрыть пароль' : 'Показать пароль'}
                >
                  {showConfirmPassword ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  ) : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1 1l22 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {error && <p className="registration-error">{error}</p>}

            <button type="submit" className="registration-submit">Зарегистрироваться</button>
          </form>

          <p className="registration-login-link">
            Уже есть аккаунт? <Link to="/log_in">Войти</Link>
          </p>
        </div>
      </main>

      <Footer />

      {(isRegistering || showSuccessModal) && (
        <div className="registration-modal-overlay">
          <div className="registration-modal">
            {isRegistering ? (
              <>
                <h2>Регистрируем...</h2>
                <p style={{ textAlign: 'center' }}>Пожалуйста, подождите, мы создаем ваш аккаунт.</p>
              </>
            ) : (
              <>
                <h2>Регистрация успешна!</h2>
                <p style={{ textAlign: 'center' }}>Теперь вы можете войти в свой аккаунт.</p>
                <button onClick={() => navigate('/log_in')} className="registration-modal-btn">
                  Войти
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Registrations;
